/**
 * @flow
 * @relayHash c5905e5dd990ac2b116e27cf25caf44d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HomeIdentifyQueryVariables = {||};
export type HomeIdentifyQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type HomeIdentifyQuery = {|
  variables: HomeIdentifyQueryVariables,
  response: HomeIdentifyQueryResponse,
|};
*/


/*
query HomeIdentifyQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HomeIdentifyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeIdentifyQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "HomeIdentifyQuery",
    "id": null,
    "text": "query HomeIdentifyQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0f82f68c851b2316e7810a97821afcbe';
module.exports = node;
